export enum UserRoleIds {
  OWNER = 8,
  ADMIN = 1,
  MANAGER = 2,
  PENDING = 3,
  SALESPERSON = 4,
  USER = 5,
  OPERATIONS = 6,
  DRIVER = 7,
}

export enum UserRoles {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  PENDING = 'PENDING',
  SALESPERSON = 'SALESPERSON',
  USER = 'USER',
  OPERATIONS = 'OPERATIONS',
  DRIVER = 'DRIVER',
}

export type UserRoleToIdMap = {
  [UserRoles.OWNER]: UserRoleIds.OWNER;
  [UserRoles.ADMIN]: UserRoleIds.ADMIN;
  [UserRoles.MANAGER]: UserRoleIds.MANAGER;
  [UserRoles.PENDING]: UserRoleIds.PENDING;
  [UserRoles.SALESPERSON]: UserRoleIds.SALESPERSON;
  [UserRoles.USER]: UserRoleIds.USER;
  [UserRoles.OPERATIONS]: UserRoleIds.OPERATIONS;
  [UserRoles.DRIVER]: UserRoleIds.DRIVER;
};

export type UserRoleEntry<T> = {
  id: string;
  role: T;
  roleId: UserRoleIds;
  labelAccessor: string;
  descriptionAccessor: string;
};

export type UserRoleCatalog = {
  [key in UserRoles]: UserRoleEntry<key>;
};
